import React from 'react';
import BigPurchasesView from './BigPurchasesView';

export default function BigPurchasesSnapshot({ onViewAll, onViewCharges, refreshKey }) {
  return (
    <div style={styles.panel}>
      <div style={styles.header}>
        <h2 style={styles.title}>💥 Big Purchases</h2>
        <button style={styles.viewAllLink} onClick={onViewAll}>
          View all in Transactions →
        </button>
      </div>
      <BigPurchasesView onViewCharges={onViewCharges} refreshKey={refreshKey} />
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.5rem',
    marginBottom: '1.25rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.9rem',
  },
  title: {
    margin: 0,
    fontSize: '0.95rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  viewAllLink: {
    background: 'transparent',
    border: 'none',
    color: '#00d4aa',
    fontSize: '0.75rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    whiteSpace: 'nowrap',
  },
};
